module.exports = __webpack_public_path__ + "img/email-orange.cc1818bd.svg";